export default __webpack_public_path__ + "locales/de/Payments.json?hash=7d35727d487c1b49b7840bcc27f0e883";